/* eslint-disable import/prefer-default-export */
import { actionTypes } from '../actionTypes'

// A standard action (FSA)
const action = (type, payload = {}, meta = {}) => ({ type, payload, meta })

// Generate an actionCreator for an actionType
// - argument is the key of the actionType object
// The created action type is simply a function that produces a standard action (see FSA spec)
// These types of functions can be mapped to dispatch in a component, or called and 'put' by a saga
export const actionCreatorForActionType = actionType => ({ [actionType]: (payload, meta) => action(actionTypes[actionType], payload, meta) })
//
// E.g. (assuming that 'nounVerb' is a generated actionType)
// actionCreatorForActionType('nounVerb')
// --> { nounVerb: (type, payload = {}, meta = {}) => ({ type, payload, meta }) }
//



// WEBPACK FOOTER //
// ./src/redux/actionCreators/generators.js